import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ShIconComponent } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardItem } from '../dashboard.model';

@Component({
    selector: 'app-dashboard-tile',
    templateUrl: './dashboard-tile.component.html',
    imports: [RouterLink, TranslateModule, ShIconComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: { class: 'block' }
})
export class DashboardTileComponent {
    public readonly item = input.required<DashboardItem>();
}
